module.exports = __webpack_public_path__ + "img/Pricetag.ab17782c.svg";